import * as React from 'react';

import { TriangleAlert } from 'lucide-react';
import { cn } from '@hqo/react-hooks';

import { LoadingButton } from 'app/components/ui/loading-button';

interface ErrorNotificationProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  buttonText?: string;
  onClick?: () => void;
  /** Shows a spinner in (and disables) the button while its action runs. */
  isLoading?: boolean;
}

export const ErrorNotification = ({
  className,
  title,
  description,
  buttonText,
  onClick,
  isLoading,
}: ErrorNotificationProps) => (
  <div
    className={cn(
      'flex flex-col items-center text-center space-y-4 p-6',
      className,
    )}
    data-testid="error-notification"
  >
    <TriangleAlert className="h-12 w-12 text-system-grey-dark" />
    <div className="space-y-2">
      <h3 className="text-lg font-semibold text-system-black">{title}</h3>
      <p className="text-sm text-system-grey-dark">{description}</p>
    </div>
    {buttonText && onClick && (
      <LoadingButton
        onClick={onClick}
        loading={isLoading}
        className="mt-4"
        data-testid="error-notification-button"
      >
        {buttonText}
      </LoadingButton>
    )}
  </div>
);
